export enum SocketConnectionState {
  initialization = 1,
  connected,
  failed
}

export interface SocketConnectionStatus {
  isConnected: boolean;
  isCreated: boolean;
  isPending: boolean
}
